/**
 * @author:
 * @file: description
 * @Date: 2019-10-08 18:09:07
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-14 20:23:31
 */
import React from 'react';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import { Switch, Redirect, Route } from 'react-router-dom';
import { ConnectedRouter } from 'connected-react-router';
import Loadable from 'react-loadable';
import SFCCheckLoginStatus from '@src/features/common/components/SFCCheckLoginStatus';

import { AyncComponentLoader, IRoute } from '@src/types';
import { SFCErrorInfo } from './features/common/components/SFCErrorInfo';
import history from './common/history';
import ErrorBoundary from './features/common/components/ErrorBoundary';

export const LoadableComponent = (loader: AyncComponentLoader) =>
  Loadable({
    loader: () =>
      loader().then(
        res => res,
        e => () => <SFCErrorInfo error message={e && e.message ? e.message : 'opps~'} />
      ),
    loading() {
      return <div className="k-common-loading">loading...</div>;
    }
  });

export function renderRouteConfig(routes: IRoute[], contextPath?: string) {
  const children: React.ReactChild[] = [];

  const renderRoute = (item: IRoute, routeContextPath?: string) => {
    let newContextPath: string;
    if (/^\//.test(item.path)) {
      newContextPath = item.path;
    } else {
      newContextPath = `${routeContextPath}/${item.path}`;
    }
    newContextPath = newContextPath.replace(/\/+/g, '/');
    const { auth, component, childRoutes, load, redirect } = item;
    let Cp = component as React.ComponentType;
    if (load) {
      Cp = Cp || LoadableComponent(load);
    }
    if (redirect) {
      const render = () => <Redirect to={redirect.match(/\/$/g) ? redirect : `${redirect}/`} />;
      children.push(<Route key={newContextPath} path={newContextPath} render={render} />);
    } else if (Cp && childRoutes) {
      const renderedChildRoutes = renderRouteConfig(childRoutes, newContextPath);
      const render = <P extends {}>(props: P) => (
        <ErrorBoundary>
          {auth === false ? (
            <Cp {...props}>{renderedChildRoutes}</Cp>
          ) : (
            <SFCCheckLoginStatus Cp={Cp} passProps={props}>
              {renderedChildRoutes}
            </SFCCheckLoginStatus>
          )}
        </ErrorBoundary>
      );
      children.push(<Route key={newContextPath} render={render} path={newContextPath} />);
    } else if (Cp) {
      const render =
        auth === false
          ? <P extends {}>(props: P) => <Cp {...props} />
          : <P extends {}>(props: P) => {
              return <SFCCheckLoginStatus Cp={Cp} passProps={props} />;
            };
      children.push(<Route key={newContextPath} render={render} path={newContextPath} exact />);
    } else if (childRoutes) {
      // 未指定 layout childRoutes 权限跟 parentRoute 的 auth 值进行 merge
      childRoutes.forEach(r =>
        renderRoute({ ...r, auth: r.auth === undefined ? auth : r.auth }, newContextPath)
      );
    }
  };

  routes.forEach(item => renderRoute(item, contextPath));

  return (
    <Switch>
      <Route path="/head" exact render={() => <Redirect to="/" />} />
      {children}
    </Switch>
  );
}

export interface IRootProps {
  store: Store;
  routeConfig: IRoute[];
}
export default class Root extends React.Component<IRootProps> {
  public render() {
    return (
      <Provider store={this.props.store}>
        <ConnectedRouter history={history}>
          {renderRouteConfig(this.props.routeConfig, '/')}
        </ConnectedRouter>
      </Provider>
    );
  }
}
